import React, { useContext } from "react";
import { Typography, Container, Box, Button } from "@mui/material";
import { ColorModeContext } from "../context/ColorModeContext";

function About() {
  const { mode } = useContext(ColorModeContext);

  return (
    <Container maxWidth="md" sx={{ textAlign: "center", mt: 0 }}>
      <Typography variant="body1" paragraph>
        Named after the Greek and Roman goddess of wisdom and war, Minerva
        symbolizes strategy, insight, and intellect. In mythology, Minerva is
        revered not only as a deity of warfare but as one who values intellect
        and strategy over brute force. She embodies the wisdom and skill
        necessary to navigate challenges with clarity and foresight, often
        accompanied by an owl, symbolizing knowledge.
      </Typography>

      <Typography variant="body1" paragraph>
        Launched in late 2024 by a dedicated chess enthusiast and the creator of
        Chessboard Magic, the project aims to offer something unique and
        valuable to the chess community, making the learning process more
        engaging and accessible. By combining advanced engine insights with
        clear, instructive narratives, this project seeks to bridge the gap
        between technical analysis and practical understanding. As it evolves,
        the platform aspires to become an essential tool for players of all
        levels, fostering deeper strategic insight, encouraging critical
        thinking, and enhancing overall enjoyment of the game.
      </Typography>

      <Typography variant="body1" paragraph>
        Minerva’s goal is straightforward but impactful: to make learning chess
        easier by adding explanations to chess engine evaluations. With clear
        and helpful descriptions, Minerva helps turn complex engine data into
        insights that anyone can understand, making it simpler to learn about
        different positions and strategies in the game.
      </Typography>

      <Typography variant="body1" paragraph>
        Minerva is a project that will grow and improve over time. New features
        and updates will be added regularly to make the platform even better.
        Our main goal is to create a useful tool for the chess community—one
        that not only helps with game analysis but also builds a deeper
        understanding and enjoyment of chess.
      </Typography>

      <Box sx={{ pb: 2 }}>
        <Button
          variant="contained"
          color="primary"
          sx={{
            mt: 2,
            mr: 2,
            textTransform: "none",
            ...(mode === "dark"
              ? {
                  boxShadow: "0 0 10px rgba(255, 255, 255, 0.3)", // Set a glowing shadow for dark mode
                  "&:hover": {
                    boxShadow: "0 0 15px rgba(255, 255, 255, 0.5)", // Increase glow on hover
                  },
                }
              : {
                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)", // Set a glowing shadow for dark mode
                  "&:hover": {
                    boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)", // Increase glow on hover
                  },
                }),
          }}
          href="https://lichess.org/@/HollowLeaf"
          target="_blank"
          rel="noopener noreferrer"
          startIcon={
            <img
              src={`${process.env.PUBLIC_URL}/img/logos/lichessdotorgwhite.png`}
              alt="lichess.org"
              style={{ width: 24, height: 24 }}
            />
          }
        >
          HollowLeaf
        </Button>

        <Button
          variant="contained"
          color="primary"
          sx={{
            mt: 2,
            mr: 2,
            textTransform: "none",
            ...(mode === "dark"
              ? {
                  boxShadow: "0 0 10px rgba(255, 255, 255, 0.3)", // Set a glowing shadow for dark mode
                  "&:hover": {
                    boxShadow: "0 0 15px rgba(255, 255, 255, 0.5)", // Increase glow on hover
                  },
                }
              : {
                  boxShadow: "0 0 10px rgba(0, 0, 0, 0.3)", // Set a glowing shadow for dark mode
                  "&:hover": {
                    boxShadow: "0 0 15px rgba(0, 0, 0, 0.5)", // Increase glow on hover
                  },
                }),
          }}
          href="https://www.chess.com/member/hollowleaf"
          target="_blank"
          rel="noopener noreferrer"
          startIcon={
            <img
              src={`${process.env.PUBLIC_URL}/img/logos/chessdotcom.png`}
              alt="chess.com"
              style={{ width: 24, height: 24 }}
            />
          }
        >
          HollowLeaf
        </Button>
      </Box>
    </Container>
  );
}

export default About;
